import React from 'react'
import { Route } from 'react-router-dom'
import { UserLoginList } from './content/user-login-list'
import { UserLoginEdit } from './content/user-login-edit'
import { UserGroupList } from './content/user-login-edit/user-list-group'
import { UserRecycle } from './content/user-recycle'
import { AnalyticCustomUser } from '../../../../view/analytics/user/analytic-user-custom'
import { RouteAssessmentResultUser } from '../../../../view/common/assessment/assessment-result-user/route-assessment-result-user'
import { useApiFormUserLogin } from '../../../../api-new/state/content'
import { Delete } from '../../../../shared/page/page-delete'
import { Purge } from '../../../../shared/page/page-purge'
import { UserLoginAdd } from './content/user-login-add'
import { UserListContent } from './content/user-login-edit/user-list-content'
import { AnalyticUserGeneral } from '../../../../view/analytics/user/analytic-user-general'
import { UserLoginAuthSession } from './content/user-login-auth-session'
import { orgUserListLinks } from '../../../../shared/error/last-owner-links'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { useParamsInt } from '../../../../shared/hooks/location'
import { IconActivityLog } from '../../../../shared/icon/icon'
import { ActivityPage } from '../../../../shared/audit/activity/activity-page'

// The user's Activity tab (audit trail phase 5): what they did and what was
// done to their account.
export const PersonActivityRoute = () => {
  const { userID } = useParamsInt()
  return (
    <BreadcrumbView Icon={IconActivityLog} text="ACTIVITY">
      <ActivityPage kind="person" id={userID} />
    </BreadcrumbView>
  )
}

export const LayoutUserLogin = () => {
  return (
    <React.Fragment>
      <Route path="/org/user/list" component={UserLoginList} />

      <Route path="/org/user/list/add" component={UserLoginAdd} />

      <Route path="/org/user/list/edit/:userID" component={UserLoginEdit} />
      <Route path="/org/user/list/edit/:userID/content" component={UserListContent} />
      <Route path="/org/user/list/edit/:userID/group" component={UserGroupList} />

      <Route path="/org/user/list/edit/:userID/auth-session" component={UserLoginAuthSession} />

      <Route path="/org/user/list/edit/:userID/activity">
        <PersonActivityRoute />
      </Route>

      <Route path="/org/user/list/recycle" component={UserRecycle} />
      <Route path="/org/user/list/edit/:deleteID/delete">
        <Delete useApiForm={useApiFormUserLogin} titleParam="email" successPath="/org/user/list" lastOwnerLinks={orgUserListLinks} />
      </Route>
      <Route path="/org/user/list/recycle/purge/:purgeID">
        <Purge useApiForm={useApiFormUserLogin} titleParam="email" successPath="/org/user/list/recycle" showServerError />
      </Route>
      <Route path="/org/user/list/edit/:userID/analytic-custom" component={AnalyticCustomUser} />
      <Route path="/org/user/list/edit/:userID/analytic-general" component={AnalyticUserGeneral} />

      <RouteAssessmentResultUser />
    </React.Fragment>
  )
}
